import classNames from "classnames";
import { Ref } from "react";

import FormInputWrapper, {
  FormInputWrapperProps,
} from "../FormInputWrapper/FormInputWrapper";

import styles from "./FormSelect.module.css";

const FormSelect: React.FC<FormSelectProps> = ({
  className,
  children,
  inputRef,
  ...props
}) => {
  return (
    <FormInputWrapper
      className={classNames(styles.wrapper, className)}
      {...props}
    >
      <select ref={inputRef}>{children}</select>
    </FormInputWrapper>
  );
};

export default FormSelect;

export type FormSelectProps = {
  inputRef?: Ref<HTMLSelectElement>;
} & FormInputWrapperProps &
  React.HTMLProps<HTMLSelectElement>;
